import { render, staticRenderFns } from "./imgP.vue?vue&type=template&id=77be7a69&scoped=true"
var script = {}
import style0 from "./imgP.vue?vue&type=style&index=0&id=77be7a69&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77be7a69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77be7a69')) {
      api.createRecord('77be7a69', component.options)
    } else {
      api.reload('77be7a69', component.options)
    }
    module.hot.accept("./imgP.vue?vue&type=template&id=77be7a69&scoped=true", function () {
      api.rerender('77be7a69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgP.vue"
export default component.exports